import React, { useState, useEffect, useRef, useContext } from "react";
import API_KEY from "../../../../api/index";
import { Input, Form, Select, Typography, Row, Col, Tooltip } from "antd";
import { EditableContext } from "./NewTable";
const { Option } = Select;
const { Text } = Typography;
const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  type,
  defaultValues,
  visible,
  attributeId,
  collectionid,
  categoryProducts,
  composite,
  data,
  setSaving,
  isInternal,
  isSizeChanged,
  changeSize,
  setCategoryProducts,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  const [attrValueId, setAttrValueId] = useState(null);

  useEffect(() => {
    if (isSizeChanged && type == "size") {
      form.setFieldsValue({
        [dataIndex + ":length"]: record[dataIndex]?.[1],
        [dataIndex + ":width"]: record[dataIndex]?.[2],
        [dataIndex + ":height"]: record[dataIndex]?.[3],
      });

      handleSave(record);
      patchAndPostAttributes();
      changeSize(false);
    }
  }, [isSizeChanged]);

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);

    if (type === "price") {
      form.setFieldsValue({
        priceOnly: record[dataIndex]?.[1],
      });
      form.setFieldsValue({
        Price: record[dataIndex],
      });
      return;
    } else if (type === "csv") {
      if (record[dataIndex]) {
        form.setFieldsValue({
          [dataIndex]:
            typeof record[dataIndex] === "string"
              ? record[dataIndex].split(",")
              : record[dataIndex],
        });
        return;
      } else {
        form.setFieldsValue({
          [dataIndex]: [],
        });
        return;
      }
    }

    // form.setFieldsValue({
    //   [dataIndex]: record[dataIndex],
    // });
  };

  const getCompositeValue = (values) => {
    const dimensionMap = {
      length: "L",
      width: "B",
      height: "H",
    };
    let size = {
      length: values[1] !== "NaN" ? values[1] : "",
      width: values[2] !== "NaN" ? values[2] : "",
      height: values[3] !== "NaN" ? values[3] : "",
    };

    let unit = values[4] || "";

    const { length = "", width = "", height = "" } = size;
    let sizeKeys = Object.keys(size);
    const validSizes = [length, width, height].filter(Boolean) || [];
    const validKeys = sizeKeys.filter((item) => size[item] && item !== "unit");
    const dimensions = validKeys.map((item) => dimensionMap[item]) || [];

    return `${validSizes.join("x")} ${unit ? unit : ""}`;
  };

  const saveComposite = async (value, key) => {
    try {
      const values = await form.validateFields();
      if (type === "size" && !isInternal) {
        const size = form.getFieldValue("size");

        let currentValues = record[dataIndex] || [null, null, null, null, null];

        const keyMap = {
          length: 1,
          width: 2,
          height: 3,
        };
        currentValues[keyMap[key]] = value;
        currentValues[0] = getCompositeValue(currentValues);

        form.setFieldsValue({ dataIndex: currentValues });

        record[dataIndex] = currentValues;
        handleSave({ ...record, dataIndex: currentValues });
        patchAndPostAttributes();
      }
    } catch (e) {}
  };

  const patchAndPostAttributes = () => {
    let editedValue = record[dataIndex]?.[0];
    let compositeValue = {
      length: record[dataIndex]?.[1] || "",
      width: record[dataIndex]?.[2] || "",
      height: record[dataIndex]?.[3] || "",
      unit: record[dataIndex]?.[4] || "",
    };

    const editedProduct = categoryProducts.find(
      (item) => item?.prodId === record?.productId
    );

    const editedAttribute = editedProduct?.attributes.find(
      (item) => item.name === dataIndex
    );

    const attributeValueId = editedAttribute?.id;
    // let editedValue = values[dataIndex];

    let requestPayloadForPatch = {
      id: attributeValueId || attrValueId,
      attribute_id: attributeId,
      values: editedValue,
      collections_products_id: record?.productId,
      composite: compositeValue,
    };

    let requestPayloadForPost = {
      collections_products_id: record?.collection_product_id,
      attribute_values_id: {
        attribute_id: attributeId,
        values: editedValue,
        composite: compositeValue,
      },
    };

    if (attributeValueId || attrValueId) {
      setSaving(true);
      API_KEY.URL.patch(
        `${API_KEY.path.attribute_values}/${attributeValueId || attrValueId}`,
        requestPayloadForPatch
      )
        .then((res) => {
          setSaving(false);
        })
        .catch((err) => {
          setSaving(false);
        });
    } else {
      setSaving(true);
      API_KEY.URL.post(
        API_KEY.path.collections_products_attribute_values,
        requestPayloadForPost
      )
        .then((res) => {
          setSaving(false);

          setAttrValueId(res?.data?.data?.attribute_values_id);
        })
        .catch((err) => {
          setSaving(false);
        });
    }
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      if (type === "price" && !isInternal) {
        const price = form.getFieldValue("Price");
        price[1] = values.priceOnly;

        form.setFieldsValue({
          Price: price,
        });
      }

      Object.keys(values).forEach((key) => {
        if (values[key] === undefined) {
          delete values[key];
        }
      });

      debugger;
      handleSave({ ...record, ...values });

      const editedProduct = categoryProducts.find(
        (item) => item?.prodId === record?.productId
      );

      const editedAttribute = editedProduct?.attributes.find(
        (item) => item.name === dataIndex
      );

      const attributeValueId = editedAttribute?.id;
      let editedValue = values[dataIndex];
      let compositeValue = composite;
      if (type === "csv") {
        editedValue = values[dataIndex].join(",");
      }

      if (type === "price" && !isInternal) {
        editedValue = record[dataIndex]?.[1];
        compositeValue = {
          currency: record[dataIndex]?.[0],
          unit: record[dataIndex]?.[2],
        };
      }
      if (type === "size" && !isInternal) {
        editedValue = record[dataIndex]?.[0];
        compositeValue = {
          length: record[dataIndex]?.[1],
          width: record[dataIndex]?.[2],
          height: record[dataIndex]?.[3],
          unit: record[dataIndex]?.[4],
        };
      }
      let requestPayloadForPatch = {
        id: attributeValueId || attrValueId,
        attribute_id: attributeId,
        values: editedValue,
        collections_products_id: record?.productId,
        composite: compositeValue,
      };

      let requestPayloadForPost = {
        collections_products_id: record?.collection_product_id,
        attribute_values_id: {
          attribute_id: attributeId,
          values: editedValue,
          composite: compositeValue,
        },
      };

      if (attributeValueId || attrValueId) {
        setSaving(true);
        API_KEY.URL.patch(
          `${API_KEY.path.attribute_values}/${attributeValueId || attrValueId}`,
          requestPayloadForPatch
        )
          .then((res) => {
            setSaving(false);
          })
          .catch((err) => {
            setSaving(false);
          });
      } else {
        setSaving(true);
        API_KEY.URL.post(
          API_KEY.path.collections_products_attribute_values,
          requestPayloadForPost
        )
          .then((res) => {
            setSaving(false);

            setAttrValueId(res?.data?.data?.attribute_values_id);
            // const newState = categoryProducts.map((item) => {
            //   if (item.collection_product_id === record.collection_product_id) {
            //     if (item?.attributes?.length > 0) {
            //       item.attributes.push({
            //         name: dataIndex,
            //         values: editedValue,
            //         composite: null,
            //         is_internal: false,
            //         id: res?.data?.data?.attribute_values_id,
            //         default: null,
            //         attribute_id: attributeId,
            //       });
            //     }
            //     // item.attributes.map((attribute) => {
            //     //   if(attribute.attribute_id === attributeId){
            //     //     attribute.id = "res.data.id";
            //     //     attribute.values=editedValue;

            //     //   }
            //     //  return  attribute
            //     // })
            //   }
            //   return item;
            // });
            // console.log("newState:", newState);
            // setCategoryProducts(newState);
          })
          .catch((err) => {
            setSaving(false);
          });
      }
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  useEffect(() => {
    if (type === "price" && !isInternal) {
      form.setFieldsValue({
        priceOnly: record[dataIndex]?.[1],
      });
      form.setFieldsValue({
        Price: record[dataIndex],
      });
      return;
    }
    if (type === "size" && !isInternal) {
      form.setFieldsValue({
        size: {
          dataIndex: record[dataIndex]?.[0],
          [dataIndex + ":length"]: record[dataIndex]?.[1],
          [dataIndex + ":width"]: record[dataIndex]?.[2],
          [dataIndex + ":height"]: record[dataIndex]?.[3],
          [dataIndex + ":unit"]: record[dataIndex]?.[4],
        },
      });
      return;
    }
    if (type === "csv") {
      if (record[dataIndex]) {
        form.setFieldsValue({
          [dataIndex]:
            typeof record[dataIndex] === "string"
              ? record[dataIndex].split(",")
              : record[dataIndex],
        });
        return;
      } else {
        form.setFieldsValue({
          [dataIndex]: [],
        });
        return;
      }
    }

    form.setFieldsValue({
      [dataIndex]: record?.[dataIndex],
    });
  }, [dataIndex, record, isInternal, type, form]);
  let childNode = children;

  const renderFields = (type) => {
    const componentsObj = {
      text: <Input ref={inputRef} onBlur={save} onPressEnter={save} />,
      csv: (
        <Select
          mode="tags"
          ref={inputRef}
          // onBlur={save}
          onPressEnter={save}
          onChange={save}
          notFoundContent={<Text type="secondary">Start typing to add...</Text>}
        >
          {defaultValues?.csv?.map(
            (item, index) =>
              item && (
                <Option key={`${index}${item}`} value={item}>
                  {item}
                </Option>
              )
          )}
        </Select>
      ),
      price: (
        <Input
          style={{ borderRadius: "0px" }}
          onWheel={(e) => e.currentTarget.blur()}
          onBlur={save}
          onPressEnter={save}
          size="medium"
          ref={inputRef}
          style={{ minWidth: 300 }}
          addonBefore={<div ref={inputRef}>{children?.[1]?.[0]}</div>}
          addonAfter={<div ref={inputRef}>{children?.[1]?.[2]}</div>}
          type="number"
          defaultValue={children?.[1]?.[0]}
        />
      ),
      size: (
        <Row style={{ minWidth: 300, marginTop: "25px" }}>
          <Col span="7">
            <Form.Item name={dataIndex + ":length"}>
              <Input
                style={{
                  borderRadius: "0",
                  borderRight: "none",
                }}
                onWheel={(e) => e.currentTarget.blur()}
                onBlur={(e) => saveComposite(e.target.value, "length")}
                name=""
                onPressEnter={(e) => saveComposite(e.target.value, "length")}
                size="medium"
                ref={inputRef}
                type="number"
                defaultValue={children?.[1]?.[1]}
              />
            </Form.Item>
          </Col>
          <Col span="7">
            <Form.Item name={dataIndex + ":width"}>
              <Input
                style={{
                  borderRadius: "0",
                  borderRight: "none",
                }}
                onWheel={(e) => e.currentTarget.blur()}
                onBlur={(e) => saveComposite(e.target.value, "width")}
                onPressEnter={(e) => saveComposite(e.target.value, "width")}
                size="medium"
                ref={inputRef}
                type="number"
                defaultValue={children?.[1]?.[2]}
              />
            </Form.Item>
          </Col>
          <Col span="10">
            <Form.Item name={dataIndex + ":height"}>
              <Input
                className="size_height"
                onWheel={(e) => e.currentTarget.blur()}
                onBlur={(e) => saveComposite(e.target.value, "height")}
                onPressEnter={(e) => saveComposite(e.target.value, "height")}
                size="medium"
                // ref={inputRef}
                addonAfter={
                  <div
                    style={{ borderRadius: "0", width: "10%" }}
                    ref={inputRef}
                  >
                    {children?.[1]?.[4]}
                  </div>
                }
                type="number"
                defaultValue={children?.[1]?.[3]}
              />
            </Form.Item>
          </Col>
        </Row>
      ),
      textarea: (
        <Input.TextArea ref={inputRef} onBlur={save} onPressEnter={save} />
      ),
      select: (
        <Select size="large" onChange={save}>
          {defaultValues && defaultValues?.select?.length > 0
            ? defaultValues?.select?.map((item, index) => (
                <Option key={`${index}${item}`} value={item}>
                  {item}{" "}
                </Option>
              ))
            : null}
        </Select>
      ),
    };
    return (
      componentsObj[type] || (
        <Input ref={inputRef} onBlur={save} onPressEnter={save} />
      )
    );
  };

  if (!visible || isInternal) {
    childNode = dataIndex ? (
      <Tooltip
        trigger="click"
        overlayInnerStyle={{ borderRadius: 8, padding: 10 }}
        title={
          // <div style={{ textAlign: "center" }}>
          //   {dataIndex ? dataIndex : "This Field"} is not being shared with the
          //   Buyer.
          // </div>

          <div>
            {/* <p>  {dataIndex ? dataIndex : "This Field"} is not being shared with the
          Buyer.</p> */}

            <p>
              This field is not being shared with Buyer. To send{" "}
              {dataIndex ? dataIndex : "This Field"}, go to Customize Buyer View
            </p>
          </div>
        }
        color={"gray"}
      >
        <div
          //className={"editable-cell-value-wrap"}
          style={{
            paddingRight: 24,
            color: "lightgray",
          }}
        >
          {type === "price" ? (
            <Row style={{ width: 250 }}>
              <Col span={8}>{children?.[1]?.[0]}</Col>
              <Col span={8}>{children?.[1]?.[1]}</Col>
              <Col span={8}>{children?.[1]?.[2]}</Col>
            </Row>
          ) : (
            children
          )}
        </div>
      </Tooltip>
    ) : (
      <div
        //className={"editable-cell-value-wrap"}
        style={{
          paddingRight: 24,
          color: "lightgray",
        }}
      >
        {type === "price" ? (
          <Row>
            <Col span={8}>{children?.[1]?.[0]}</Col>
            <Col span={8}>{children?.[1]?.[1]}</Col>
            <Col span={8}>{children?.[1]?.[2]}</Col>
          </Row>
        ) : (
          children
        )}
      </div>
    );
  } else {
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={type === "price" && !isInternal ? "priceOnly" : dataIndex}
        >
          {renderFields(type)}
        </Form.Item>
      ) : (
        <Form.Item
          style={{
            margin: 0,
          }}
          onClick={toggleEdit}
          name={type === "price" && !isInternal ? "priceOnly" : dataIndex}
        >
          {renderFields(type)}
        </Form.Item>
      );
    }
  }
  return <td {...restProps}>{childNode} </td>;
};

export default EditableCell;
